import { injectScript } from "./utils";

const TryDatacops = {
  init(apiKey: string, serverUrl?: string) {
    injectScript(apiKey, serverUrl);
  },
  eventSetup(type: string, data: any) {
    if (!window.tdcScope) {
      window.tdcScope = [];
    }
    window.tdcScope.push(
      window.tdcScope.push({
        type,
        data,
      })
    );
  },
};

export default TryDatacops;
